import React, { ReactNode } from "react";

interface DashboardHeaderProps {
  children?: ReactNode;
  title: string;
  desc?: string;
  width?: string;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  children,
  title,
  desc,
  width,
}) => {
  return (
    <div className={` pb-2 pt-5  flex items-start md:items-center md:gap-16 gap-2  justify-between ${width && width} sm:flex-row flex-col`}>
      <h1 className="md:text-3xl text-xl text-gray-800 font-semibold md:mb-2 w-full"> {title} <span className="text-primary-red text-sm"  >{desc}</span></h1>
      {children}
    </div>
  );
};

export default DashboardHeader;
